<div class="app-panel app-panel--nested">
  <div class="app-panel__header">
    <h4 class="app-panel__title">{{ i18n().t('checklistCreator.definition.numberWithUnitTitle') }}</h4>
  </div>
  <div class="checklist-creator__definition-grid" [formGroup]="form()">
    <label class="app-field">
      <span class="app-field__label">{{ i18n().t('checklistCreator.fields.unit') }}</span>
      <input type="text" formControlName="numberWithUnit" [placeholder]="i18n().t('checklistCreator.placeholders.unit')" />
    </label>
  </div>
  <div class="checklist-creator__array-section">
    @for (bucket of buckets().controls; track $index) {
      <div class="checklist-creator__array-row" [formGroup]="asFormGroup(bucket)">
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.bucketMin') }}</span>
          <input type="number" formControlName="minValue" />
        </label>
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.bucketMax') }}</span>
          <input type="number" formControlName="maxValue" />
        </label>
        <label class="app-field">
          <span class="app-field__label">{{ i18n().t('checklistCreator.fields.bucketScore') }}</span>
          <input type="number" formControlName="score" />
        </label>
        @if (!isReadOnly()) {
          <button class="secondary-button" type="button" (click)="removeBucketRequested()($index)">{{ i18n().t('checklistCreator.actions.remove') }}</button>
        }
      </div>
    }
    @if (!isReadOnly()) {
      <button class="secondary-button" type="button" (click)="addBucketRequested()()">{{ i18n().t('checklistCreator.actions.addBucket') }}</button>
    }
  </div>
</div>
